export const API_URL = 'https://sticket-api-sjzgaswksq-ew.a.run.app'
//export const API_URL = 'http://localhost:8080'
//export const API_URL = 'https://dev-api-davide.plesh.co'
